import React from 'react';
import { IPRIVATE_MARKDOWN_TIMING_SECTION_HEADERProps, PRIVATE_MARKDOWN_TIMING_SECTION_HEADER } from './heading';
import { getTheme, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import { MarkdownContent } from '../content';
import { TimingMode } from '../../../../entities/timing-mode';
import { TimingState } from '../../../../entities/timing-state';

interface IMarkdownTimedSectionProps extends IPRIVATE_MARKDOWN_TIMING_SECTION_HEADERProps {}

const getSectionClasses = (theme: ITheme) => {
  const section: IStyle = {
    backgroundColor: theme.palette.white,
    borderRadius: '0.25em',
    boxShadow: `0 3.2px 7.2px 0 rgba(0, 0, 0, .132),0 .6px 1.8px 0 rgba(0, 0, 0, .108)`,
    fontSize: '1em',
    marginBottom: '1.5em',
  };
  
  const contentBody: IStyle = {
    fontSize: '1em',
    padding: '1.5em',
    paddingBottom: '0.5em',
  };

  const divider: IStyle = {
    width: '100%',
    margin: 0,
    padding: 0,
    borderTop: `1px solid ${theme.palette.neutralQuaternary}`,
  }

  return mergeStyleSets({
    section,
    contentBody,
    divider,
  });
}

export const MarkdownTimedSection: React.FunctionComponent<IMarkdownTimedSectionProps> = (props) => {
  const { componentModel } = props;
  const theme = getTheme();
  const classes = getSectionClasses(theme);

  const displayHeader = componentModel.specType !== TimingMode.Preamble;
  const displayBody = componentModel.notes.length > 0
    && (componentModel.hideNotes === false || componentModel.timingState === TimingState.Active);

  return (
    <section className={classes.section}>
      {displayHeader && <PRIVATE_MARKDOWN_TIMING_SECTION_HEADER {...props} />}
      {displayHeader && displayBody && <div className={classes.divider} />}
      {displayBody &&
      <div className={classes.contentBody}>
        {componentModel.notes.map(model => <MarkdownContent
          key={`${model.startLineNumber}-${model.endLineNumber}`}
          componentModel={model}
          hostSectionIsTimed={componentModel.specType !== TimingMode.Preamble}
        />)}
      </div>}
    </section>
  );
};
